import { Box, Theme, Typography } from '@material-ui/core'
import { PropsWithChildren } from 'react'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme: Theme) => ({
  avatar: {
    backgroundColor: 'rgb(253,241,218)',
  },
  icon: {
    height: 16,
    width: 16,
    color: 'rgb(244,190,73)',
  },
  summary: {
    marginRight: theme.spacing(2),
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',

    gap: theme.spacing(3),
    padding: theme.spacing(2),
  },
}))

const PreviewSection = ({ children, title }: PropsWithChildren<{ title: string }>) => {
  const classes = useStyles()
  return (
    <Box className={classes.column}>
      <Typography
        variant="h6"
        noWrap
      >
        {title}
      </Typography>
      {children}
    </Box>
  )
}

export default PreviewSection
